import { Device } from '@twilio/voice-sdk';
import { get_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';

const getUrl = (endpoint) => {
  if (import.meta.env.VITE_TWILIO_CALL_BASE_URL) {
    return `${import.meta.env.VITE_TWILIO_CALL_BASE_URL}${endpoint}`;
  }

  return get_api_url(endpoint);
};

const getToken = async () => {
  const url = getUrl('/v2/twilio_call/token');
  const resp = await get_api(url, true);
  return resp.data?.data?.token;
};

export const resolveContact = async (studentUuid) => {
  const url = `${getUrl('/v2/twilio_call/resolve_contact')}?student_uuid=${encodeURIComponent(studentUuid)}`;
  const resp = await get_api(url, true);
  return resp.data?.data;
};

export const getOutgoingCallerId = async (studentUuid) => {
  const url = `${getUrl('/v2/twilio_call/outgoing_caller_id')}?student_uuid=${encodeURIComponent(studentUuid)}`;
  const resp = await get_api(url, true);
  return resp.data?.data?.from_number;
};

export const listCalls = async (studentUuid) => {
  const url = `${getUrl('/v2/twilio_call/calls')}?student_uuid=${encodeURIComponent(studentUuid)}`;
  const resp = await get_api(url, true);
  return resp.data?.data?.calls || [];
};

export const getRecordingURL = async (callUuid) => {
  const url = `${getUrl('/v2/twilio_call/recording_url')}?call_uuid=${encodeURIComponent(callUuid)}`;
  const resp = await get_api(url, true);
  return resp.data?.data?.url;
};

/**
 * Start an outbound call via Twilio Voice SDK.
 * onStatus is invoked with one of: connecting | ringing | connected | failed | ended.
 * Returns an object with { hangup } the caller uses to end the call.
 */
export const startCall = async ({ toNumber, fromNumber, studentUuid, onStatus, onMuteChange }) => {
  onStatus('connecting');

  const token = await getToken();
  if (!token) throw new Error('Failed to fetch Twilio token');

  const device = new Device(token);

  const params = { To: toNumber };
  if (fromNumber) params.CallerId = fromNumber;
  if (studentUuid) params.StudentUUID = studentUuid;
  const call = await device.connect({ params });

  call.on('ringing', () => onStatus('ringing'));
  call.on('accept', () => onStatus('connected'));
  call.on('disconnect', () => {
    onStatus('ended');
    device.destroy();
  });
  call.on('cancel', () => {
    onStatus('ended');
    device.destroy();
  });
  call.on('error', (err) => {
    console.error('Twilio call error', err);
    onStatus('failed');
    device.destroy();
  });
  call.on('mute', (isMuted) => {
    if (onMuteChange) onMuteChange(!!isMuted);
  });

  return {
    hangup: () => {
      try {
        call.disconnect();
      } catch (e) {
        console.error('hangup error', e);
      }
    },
    toggleMute: () => {
      try {
        const next = !call.isMuted();
        call.mute(next);
        return next;
      } catch (e) {
        console.error('mute error', e);
        return false;
      }
    }
  };
};
